var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gvl-funding" }, [
      _c("h2", [
        _vm._v(
          "Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR"
        )
      ]),
      _c("div", { staticClass: "notice-box" }, [
        _vm._v(
          "Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind."
        )
      ]),
      _c("h3", { staticClass: "mt-4" }, [_vm._v("Stipendienprogramm")]),
      _c("p", [
        _vm._v(
          "Im Rahmen des von der Beauftragten der Bundesregierung für Kultur und Medien initiierten\nStipendienprogramms der Verwertungsgesellschaften in NEUSTART KULTUR schreibt die\nGesellschaft zur Verwertung von Leistungsschutzrechten mbH (GVL) ein Stipendienprogramm 2021 aus."
        )
      ]),
      _c("p", [
        _vm._v(
          "Durch die COVID-19-Pandemie sind wesentliche Vertriebswege, Vermittlungsplattformen und\nKommunikationsorte im Kulturbereich weggebrochen. Veranstaltungsorte wie Konzerthallen oder\nTheater befinden sich seit über einem Jahr im Ausnahmezustand; Musik-, Fernseh- und\nFilmproduktionen konnten nur stark eingeschränkt stattfinden, mussten in die Zukunft verlegt oder in\nden digitalen Raum verschoben werden. Neue Produktionen können nicht im Kino gezeigt werden.\nVor diesem Hintergrund müssen viele ausübende Künstler*\n1 signifikante Einnahmeausfälle erleiden.\nGleichzeitig bieten die Umstände aber auch eine Chance, die Bedeutung der eigenen künstlerischen\nArbeit zu reflektieren und neue Formen der Produktion, Aufführung und Vermittlung zu entwickeln.\nKreatives Potenzial bieten in dieser Situation nicht zuletzt auch Überlegungen zu alternativen, auch\ndigitalen Formaten."
        )
      ]),
      _c("h3", [_vm._v("Fördergegenstand")]),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Das Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR zielt darauf\nab freiberufliche oder auf Produktionsdauer beschäftigte ausübende Künstler* dabei zu\nunterstützen, ihre Arbeit trotz Einschränkungen durch die COVID-19-Pandemie fortsetzen zu\nkönnen. Die Stipendien sollen Künstlern* ermöglichen, Ideen in der Zeit während und nach\nder durch die Corona-Pandemie bedingten Einschränkungen zu entwickeln. Das können\nbeispielsweise Recherchearbeiten sein, Weiterbildungen im Beruf des ausübenden Künstlers,\nKonzepte sowohl im digitalen als auch im öffentlichen Raum sowie die Produktion von\nmedialen Inhalten. Grundsätzlich werden keine Auslands- oder Wissenschaftsstipendien\ngefördert."
          )
        ]),
        _c("li", [
          _vm._v(
            "Das Stipendienprogramm umfasst Stipendien in Höhe von EUR 5.000,00 pro Person für eine Stipendiendauer von vier Monaten."
          )
        ])
      ]),
      _c("h3", [_vm._v("Ziele der Förderung")]),
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          "Mit dem Stipendienprogramm sollen folgende Ziele erreicht werden:"
        )
      ]),
      _c("table", [
        _c("tr", [
          _c("th", [_c("h4", [_vm._v("Ziele des Programms")])]),
          _c("th", [_c("h4", [_vm._v("Förderinhalte")])]),
          _c("th", [_c("h4", [_vm._v("Mögliche Nachweisdokumente")])])
        ]),
        _c("tr", [
          _c("td", [
            _vm._v(
              "Ziel des Programms ist, das Aufrechterhalten der professionellen Fertigkeiten von Kreativen auch jenseits der Öffentlichkeit zu ermöglichen,\nz. B. durch Recherchieren, Üben, Proben, Trainieren oder der Entwicklung neuer kreativer Ansätze, bis die Öffentlichkeit\nwieder durch Projekte, Veranstaltungen oder Engagements einbezogen werden kann."
            )
          ]),
          _c("td", [
            _vm._v(
              "Maßnahmen, wie z.B. die Entwicklung und Umsetzung von Online-Formaten, interaktiven Projekten, OnlineKooperationen, die die\nkünstlerische Darbietung zum Gegenstand haben, Rechercheprojekte für künftige Produktionen mit künstlerischen Darbietungen,\nProjekte mit künstlerischen Darbietungen, die mit Unterstützung des Stipendiums realisiert werden sollen."
            )
          ]),
          _c("td", [
            _vm._v(
              "Nachweis von Online-Formaten der künstlerischen Darbietungen (URLs, Veröffentlichungsdatum), Projekt- und Rechercheberichte bzw.\nKonzepte (im PDF-Format)."
            )
          ])
        ]),
        _c("tr", [
          _c("td", [
            _vm._v(
              "Kulturschaffende sollen befähigt werden, die aktuelle Situation kreativ für ihre künstlerische Weiterentwicklung zu nutzen, insbesondere die Erarbeitung\nzukunftsweisender Konzepte und sinnstiftender Formate sowie im Hinblick auf Nachhaltigkeit und zum Weiterdenken bestehender Strukturen (Überbrückung).\nMithilfe des Stipendiums soll der hierfür notwendige materielle Rahmen geschaffen werden."
            )
          ]),
          _c("td", [
            _vm._v(
              "Maßnahmen, wie z.B. die Aneignung und Erprobung neuer Techniken und Arbeitsweisen, Fortbildungsmaßnahmen für künstlerische Darbietungen."
            )
          ]),
          _c("td", [
            _vm._v(
              "Rechnung der Weiterbildungsmaßnahme, Aus- und Weiterbildungszertifikate, Angaben zu Dauer und Inhalten der Aus- und Weiterbildungsmaßnahme."
            )
          ])
        ])
      ]),
      _c("p", { staticClass: "mt-2" }, [
        _vm._v(
          "Der Antragsteller* nimmt für das bei der GVL beantragte Projekt innerhalb des viermonatigen Förderzeitraums kein anderes Stipendium oder Förderprogramm des Bundes, der Länder oder der\nKommunen in Anspruch. Über das Sonderförderprogramm kann pro Person maximal ein Stipendium vergeben werden."
        )
      ]),
      _c("p", [
        _vm._v(
          "Die Stipendien dienen anderen Zwecken als der Sicherung des Lebensunterhalts Sie sind deshalb\nnicht unmittelbar als Einkommen (eigener Art neben dem Einkommen aus selbständiger\nErwerbstätigkeit) in der Grundsicherung für Arbeitssuchende (Arbeitslosengeld II) zu berücksichtigen."
        )
      ]),
      _c("h3", [_vm._v("Zuwendungsempfänger")]),
      _c("p", [
        _vm._v(
          "Antragsberechtigt sind natürliche Personen mit Hauptwohnsitz in Deutschland."
        )
      ]),
      _c("p", [
        _vm._v(
          "Das Förderprogramm richtet sich an professionell freiberuflich oder auf Produktionsdauer beschäftigte ausübende Künstler* die ihre\nkünstlerische Tätigkeit im Haupterwerb betreiben. Der Nachweis erfolgt grundsätzlich über die Mitgliedschaft in der Künstlersozialkasse."
        )
      ]),
      _c("p", [
        _vm._v(
          "Zusätzlich ist ein Nachweis über die Mitgliedschaft in der GVL zu erbringen. Der\nWahrnehmungsvertrag muss zum Zeitpunkt des Abschlusses des Fördervertrags vorliegen; ein\nAntrag auf Abschluss eines Wahrnehmungsvertrags mit der GVL kann bis zum Ende der\nAusschreibungsphase gestellt werden. Antragsteller*, die ihre Eigenschaft als ausübender Künstler*\nhinreichend belegen, können auch ohne Wahrnehmungsvertrag gefördert werden."
        )
      ]),
      _c("p", [
        _vm._v(
          "Künstler* ohne KSK-Mitgliedschaft weisen ihre Eigenschaft als ausübender Künstler* durch aussagekräftige Dokumente nach (siehe unten)."
        )
      ]),
      _c("p", [
        _vm._v(
          "Berufsanfänger* ohne KSK-Mitgliedschaft weisen ein Abschlusszeugnis oder Diplom einer künstlerischen Ausbildung nach (siehe unten)."
        )
      ]),
      _c("p", [
        _vm._v(
          "Der Antragsteller* darf im Jahr 2020 maximal Einkünfte in Höhe von EUR 60.000,00 erzielt haben,\nunabhängig von der Art der Einkünfte. Bei Antragstellung ist der ESt-Bescheid 2020 einzureichen.\nSollte der ESt-Bescheid 2020 noch nicht vorliegen, reicht der Antragsteller* hilfsweise den EStBescheid 2019 und versichert zusätzlich, dass der Gesamtbetrag der Einkünfte im Jahr 2020 den\nWert von EUR 60.000,00 nicht übersteigt."
        )
      ]),
      _c("p", [
        _vm._v(
          "Nicht antragsberechtigt sind Juroren des vorliegenden Programms."
        )
      ]),
      _c("p", [
        _vm._v(
          "Der Antragsteller* verfügt über ein eigenes Girokonto mit einer IBAN-Nummer und über eine eigene E-Mail-Adresse."
        )
      ]),
      _c("p", [
        _vm._v(
          "Der Antragsteller* willigt in die Erklärung zur Datenverarbeitung und Datenverwendung ein."
        )
      ]),
      _c("p", [
        _vm._v(
          "Der Antragssteller* füllt die Pflichtfelder des elektronischen Förderantrags vollständig aus, lädt die\neinzureichenden Dokumente vollständig elektronisch hoch und sendet den Antrag auf dem vorgesehenen elektronischen Weg an die GVL."
        )
      ]),
      _c("h3", [_vm._v("Verfahren")]),
      _c("p", [
        _vm._v(
          "Nach Erhalt des Zuwendungsbescheids vom Bundesverwaltungsamt (BVA) erfolgt eine offizielle zweiwöchige Bekanntmachung des Stipendienprogramms der Verwertungsgesellschaften in NEUSTART\nKULTUR auf der Website der GVL www.gvl.de. Nach Ablauf dieser zwei Wochen beginnt die sechswöchige Bewerbungsphase."
        )
      ]),
      _c("p", [
        _vm._v(
          "Die Bewerbungsphase kann vorzeitig beendet werden, sobald genügend Anträge eingegangen sind, dass eine Auskehrung der maximalen Anzahl an Stipendien sichergestellt ist."
        )
      ]),
      _c("p", [
        _vm._v(
          "Für den Fall, dass innerhalb des Bewerbungszeitraums der vollständige Förderbetrag nicht ausgeschöpft wurde, kann eine weitere Bewerbungsrunde à sechs Wochen eröffnet werden kann."
        )
      ]),
      _c("p", [
        _vm._v(
          "Die Anträge werden entsprechend der Reihenfolge ihres Eingangs bearbeitet. Anträge gelten erst dann als formal ordnungsgemäß gestellt,\nwenn sämtliche antragsbegründende Unterlagen zur Prüfung vorliegen."
        )
      ]),
      _c("p", [
        _vm._v(
          "Die GVL benennt mindestens eine dreiköpfige unabhängige Jury. Diese setzt sich zusammen aus\nzwei Vertretern der ausübenden Künstler* und möglichst einem Mitarbeiter* der GVL, wobei eine\nGender-paritätische Besetzung angestrebt wird. Jeder formal korrekt eingereichte und vollständige\nFörderantrag, der die Antragsfrist eingehalten hat, wird von einer Jury begutachtet. Über das\nVerfahren und die Kriterien der Jurierung entscheidet die GVL."
        )
      ]),
      _c("p", [
        _vm._v(
          "Es besteht kein Rechtsanspruch auf Förderung. Die Entscheidung über eine Förderung\ntrifft allein die zuständige Jury. Nach abgeschlossener Prüfung erhält der Antragsteller* eine\nInformation per E-Mail über die Bewilligung oder Ablehnung des Antrages. Im Falle eines positiven\nJuryentscheids erhält der Antragssteller* einen Fördervertrag, welcher der GVL innerhalb von zwei\nWochen nach Erhalt unterzeichnet vorliegen muss. Andernfalls verfällt die positive Juryentscheidung."
        )
      ]),
      _c("p", { staticClass: "mb-1" }, [
        _vm._v("Dem Antrag sind folgende Unterlagen beizufügen:")
      ]),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Darstellung des konzeptionellen Vorhabens, das im Rahmen des Stipendiums umgesetzt werden soll (max. 2.000 Zeichen)"
          )
        ]),
        _c("li", [_vm._v("künstlerische Vita (max. 800 Zeichen)")]),
        _c("li", [
          _vm._v(
            "Auflistung von durchgeführten Konzerten / Aufführungen / Produktionen in den Jahren 2019 und 2020"
          )
        ]),
        _c("li", [
          _vm._v(
            "ESt-Bescheid 2020; sollte der ESt-Bescheid 2020 noch nicht vorliegen, übermittelt der Antragsteller* hilfsweise den ESt-Bescheid 2019 und versichert, dass der\nGesamtbetrag der Einkünfte im Jahr 2020 den Betrag von EUR 60.000,00 nicht übersteigt."
          )
        ]),
        _c("li", [
          _vm._v(
            "Nachweis über die Mitgliedschaft in der Künstlersozialkasse (KSK)"
          )
        ]),
        _c("li", [
          _vm._v("betrifft nur Antragsteller ohne KSK-Mitgliedschaft:"),
          _c("ul", [
            _c("li", { staticClass: "mt-1" }, [
              _vm._v(
                "aktueller Nachweis über die ausgeübte künstlerische Selbständigkeit gem. § 18 EstG oder"
              )
            ]),
            _c("li", { staticClass: "mt-1" }, [
              _vm._v(
                "Sozialversicherungsnachweis, dessen Tätigkeitsschlüssel mit 94 (darstellende Berufe) beginnt lt. Klassifizierung der Berufe 2010 o.ä."
              )
            ])
          ])
        ]),
        _c("li", [
          _vm._v("betrifft nur Berufsanfänger ohne KSK-Mitgliedschaft:"),
          _c("ul", [
            _c("li", { staticClass: "mt-1" }, [
              _vm._v("Abschlusszeugnis einer künstlerischen Ausbildung oder")
            ]),
            _c("li", { staticClass: "mt-1" }, [
              _vm._v("Diplom künstlerisches Studium")
            ]),
            _c("li", { staticClass: "mt-1" }, [
              _vm._v(
                "alternativ: Verträge, Honorarabrechnungen über Engagements"
              )
            ])
          ])
        ]),
        _c("li", [
          _vm._v(
            "Nachweis über den Hauptwohnsitz (Kopie des Personalausweises Vorder- + Rückseite, alternativ Reisepass + Meldebescheinigung)."
          )
        ])
      ]),
      _c("p", [
        _vm._v(
          "Die Antragsberatung, Prüfung, Gewährung und Auszahlung der Fördermittel erfolgen durch die GVL.\nDie Stipendien werden als einmalige, nicht rückzahlbare Zuwendung analog der §§ 23, 44 der\nBundeshaushaltsordnung einschließlich der hierzu erlassenen Verwaltungsvorschriften im Wege\neines privatrechtlichen Fördervertrages gewährt. Für die ggf. erforderliche Aufhebung und die\nRückforderung der gewährten Förderung gelten analog die §§ 48 bis 49a des Verwaltungsverfahrensgesetzes (VwVfG)."
        )
      ]),
      _c("p", [
        _vm._v(
          "Nach Eingang des unterzeichneten Fördervertrags überweist die GVL dem Antragssteller* in 90% der\nFördersumme (EUR 4.500,00) auf das im Förderantrag angegebene Girokonto."
        )
      ]),
      _c("p", [
        _vm._v(
          "Die Dauer des Stipendiums beträgt vier Monate. Das Stipendium beginnt mit dem\nÜberweisungsdatum des Förderbetrags und endet vier Monate später. Innerhalb des letzten (vierten)\nMonats ist ein Sachbericht (mindestens 1.000 Zeichen und maximal 5.000 Zeichen) des Stipendiaten\neinzureichen, aus dem hervorgeht, wie das beantragte Projekt umgesetzt wurde. Nach Eingang des\nSachberichts wird nach positiver Prüfung die zweite Tranche in Höhe von EUR 500,00 ausgezahlt."
        )
      ]),
      _c("p", [
        _vm._v(
          "Unrichtige Angaben bzw. unrichtige Nachweise bei der Antragsstellung und/oder eine Verletzung der\nim Fördervertrag festgelegten Pflichten können zu Rückforderungen der Stipendiengelder führen."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }